import * as React from 'react';
import { WrapperContainer } from '../../../../constants/globalStyles';

export default class extends React.PureComponent {
  render() {
    const { narrowed, children } = this.props;
    return <WrapperContainer narrowed={narrowed}>{children}</WrapperContainer>;
  }
}
